var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 17.6 17.6",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.8 17.3a.48.48 0 0 1-.37-.17C8.18 16.86 2.3 10.27 2.3 6.8 2.3 3.22 5.22.3 8.8.3s6.5 2.92 6.5 6.5c0 3.46-5.88 10.05-6.13 10.33a.48.48 0 0 1-.37.17m0-16a5.51 5.51 0 0 0-5.5 5.5c0 2.38 3.68 7.13 5.5 9.24 1.82-2.11 5.5-6.86 5.5-9.24 0-3.03-2.47-5.5-5.5-5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.8 9.3a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5"
})));
export default SvgLocation;